import React from 'react'
import { SequenceAnimator } from 'react-sequence-animator';
import Cat1 from "./blackLogo/LB LOGO BLACK00.png"
import Cat2 from "./blackLogo/LB LOGO BLACK01.png"
import Cat3 from "./blackLogo/LB LOGO BLACK02.png"
import Cat4 from "./blackLogo/LB LOGO BLACK03.png"
import Cat5 from "./blackLogo/LB LOGO BLACK04.png"
import Cat6 from "./blackLogo/LB LOGO BLACK05.png"
import Cat7 from "./blackLogo/LB LOGO BLACK06.png"
import Cat8 from "./blackLogo/LB LOGO BLACK07.png"
import Cat9 from "./blackLogo/LB LOGO BLACK08.png"
import Cat10 from "./blackLogo/LB LOGO BLACK09.png"
import Cat11 from "./blackLogo/LB LOGO BLACK10.png"
import Cat12 from "./blackLogo/LB LOGO BLACK11.png"
import Cat13 from "./blackLogo/LB LOGO BLACK12.png"
import Cat14 from "./blackLogo/LB LOGO BLACK13.png"
import Cat15 from "./blackLogo/LB LOGO BLACK14.png"
import Cat16 from "./blackLogo/LB LOGO BLACK15.png"
import Cat17 from "./blackLogo/LB LOGO BLACK16.png"
import Cat18 from "./blackLogo/LB LOGO BLACK17.png"
import Cat19 from "./blackLogo/LB LOGO BLACK18.png"
import Cat20 from "./blackLogo/LB LOGO BLACK19.png"
import Cat21 from "./blackLogo/LB LOGO BLACK20.png"
import Cat22 from "./blackLogo/LB LOGO BLACK21.png"
import Cat23 from "./blackLogo/LB LOGO BLACK22.png"
import Cat24 from "./blackLogo/LB LOGO BLACK23.png"
import Cat25 from "./blackLogo/LB LOGO BLACK24.png"
import Cat26 from "./blackLogo/LB LOGO BLACK25.png"
import Cat27 from "./blackLogo/LB LOGO BLACK26.png"
import Cat28 from "./blackLogo/LB LOGO BLACK27.png"
import Cat29 from "./blackLogo/LB LOGO BLACK28.png"
import Cat30 from "./blackLogo/LB LOGO BLACK29.png"
import Cat31 from "./blackLogo/LB LOGO BLACK30.png"
import Cat32 from "./blackLogo/LB LOGO BLACK31.png"
import Cat33 from "./blackLogo/LB LOGO BLACK32.png"
import Cat34 from "./blackLogo/LB LOGO BLACK33.png"
import Cat35 from "./blackLogo/LB LOGO BLACK34.png"

const LogoBLACKAnimator = () => {
    return (
        <SequenceAnimator autoplay loop={false} >
            <img src={Cat1} alt="cat1" width="210px" />
            <img src={Cat2} alt="cat1" width="210px" />
            <img src={Cat3} alt="cat1" width="210px" />
            <img src={Cat4} alt="cat1" width="210px" />
            <img src={Cat5} alt="cat1" width="210px" />
            <img src={Cat6} alt="cat1" width="210px" />
            <img src={Cat7} alt="cat1" width="210px" />
            <img src={Cat8} alt="cat1" width="210px" />
            <img src={Cat9} alt="cat1" width="210px" />
            <img src={Cat10} alt="cat1" width="210px" />
            <img src={Cat11} alt="cat1" width="210px" />
            <img src={Cat12} alt="cat1" width="210px" />
            <img src={Cat13} alt="cat1" width="210px" />
            <img src={Cat14} alt="cat1" width="210px" />
            <img src={Cat15} alt="cat1" width="210px" />
            <img src={Cat16} alt="cat1" width="210px" />
            <img src={Cat17} alt="cat1" width="210px" />
            <img src={Cat18} alt="cat1" width="210px" />
            <img src={Cat19} alt="cat1" width="210px" />
            <img src={Cat20} alt="cat1" width="210px" />
            <img src={Cat21} alt="cat1" width="210px" />
            <img src={Cat22} alt="cat1" width="210px" />
            <img src={Cat23} alt="cat1" width="210px" />
            <img src={Cat24} alt="cat1" width="210px" />
            <img src={Cat25} alt="cat1" width="210px" />
            <img src={Cat26} alt="cat1" width="210px" />
            <img src={Cat27} alt="cat1" width="210px" />
            <img src={Cat28} alt="cat1" width="210px" />
            <img src={Cat29} alt="cat1" width="210px" />
            <img src={Cat30} alt="cat1" width="210px" />
            <img src={Cat31} alt="cat1" width="210px" />
            <img src={Cat32} alt="cat1" width="210px" />
            <img src={Cat33} alt="cat1" width="210px" />
            <img src={Cat34} alt="cat1" width="210px" />
            <img src={Cat35} alt="cat1" width="210px" />
        </SequenceAnimator>
    )
}

export default LogoBLACKAnimator